export default __webpack_public_path__ + "menu-customers-icon.c4f6d124cda4d1ac6f784e35feb73753.svg";